.thead {
  position: sticky;
  top: 0;
  background-color: var(--table-header-color);
  padding: 10px;
  transition: box-shadow 150ms ease;
  z-index: 10;
  border-radius: var(--mantine-radius-md);
  padding: var(--mantine-spacing-xs) var(--mantine-spacing-sm);
  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
  }
}

.table {
  border-collapse: separate !important;
  border-radius: var(--mantine-radius-sm);
}

.scrollArea {
  border-radius: var(--mantine-radius-md);
  border: 1px solid var(--mantine-color-gray-1);
}

.mantine-ScrollArea-viewport > :first-child {
  height: 100%;
}

.td {
  background-color: white;
}
.thead {
  border-radius: var(--mantine-radius-sm);
  padding: var(--mantine-spacing-xs) var(--mantine-spacing-sm);
}
.th {
  background-color: var(--table-header-color);
  border-bottom: 1px solid var(--mantine-color-primary-0);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 10rem;
  width: 150px;
  &:hover:not([data-action-cell="true"]) {
    cursor: pointer;
    background-color: darken(var(--table-header-color), 10%);
  }
}

.td p {
  font-size: var(--mantine-font-size-sm);
}

.tr:nth-child(even) > .td {
  background-color: var(--table-line-hover-color) !important;
}

.tr:hover .td,
.tr:hover .td[data-last-left-pinned="true"],
.tr:hover .td[data-last-right-pinned="true"] {
  background-color: darken(var(--table-line-hover-color), 5%) !important;
}

.scrolled {
  box-shadow: var(--mantine-shadow-sm);
}

.th[data-last-left-pinned="true"],
.td[data-last-left-pinned="true"] {
  border-right: 1px solid var(--mantine-color-gray-1);
  z-index: 3;
}

.th[data-last-left-pinned="true"]::after {
  content: "";
  position: absolute;
  top: 0;
  right: -5px;
  width: 3px;
  height: 100%;
  overflow: visible;
  pointer-events: none;
  background: linear-gradient(
    to right,
    var(--mantine-color-gray-3),
    transparent
  );
  filter: blur(5px);
}

.th[data-last-right-pinned="true"]::before {
  content: "";
  position: absolute;
  top: 0;
  left: -5px;
  width: 3px;
  height: 100%;
  pointer-events: none;
  background: linear-gradient(to left, var, transparent);
  filter: blur(5px);
}

.td[data-pinned="true"] {
  background-color: var(--mantine-color-white);
}

.th[data-pinned="true"],
.td[data-pinned="true"] {
  z-index: 2;
  position: sticky;
}
